import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from 'notistack';
import { Box, MenuItem } from '@mui/material';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },

  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    marginTop: 20,
    borderRadius: 25,
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const CurrencyRateCreate = ({
  list,
  allCountry,
  editObj,
  setEditObj,
  editIndexNo,
  refresh,
  setRefresh,
  closeAddDialog,
  addDialog,
}) => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [id, setId] = useState('');
  const [sourceCurrency, setSourceCurrency] = useState('');
  const [usdToSourceRate, setUsdToSourceRate] = useState('');

  const [loading, setLoading] = useState(false);
  const [addForm, setAddForm] = useState(true);
  const [editForm, setEditForm] = useState(false);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();

    setLoading(true);
    let response;
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    let formData = {
      sourceCurrency,
      usdToSourceRate,
    };
    try {
      response = await axios({
        url: `/api/v1/private/currency-conversion-rate`,
        method: 'post',
        data: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      list[editIndexNo] = response.data.data;
      setRefresh(!refresh);

      closeAddDialog();

      handleSnakbarOpen(response.data.message, 'success');
    } catch (error) {
      // console.log('e', error.response.data.errors);
      handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          Add Currency Conversion Rate
        </Typography>
      </div>

      <form onSubmit={handleSubmit}>
        <TextField
          label="USD To Source Rate"
          variant="outlined"
          type="number"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={usdToSourceRate}
          onChange={e => setUsdToSourceRate(e.target.value)}
        />

        <TextField
          variant="outlined"
          select
          label="Source Currency"
          size="small"
          fullWidth
          required
          value={sourceCurrency}
          onChange={e => setSourceCurrency(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          {allCountry.map((e, index) => (
            <MenuItem value={e.currency} key={index}>
              <Box className={classes.inner}>
                <img src={e.flag} style={{ maxWidth: 24, marginRight: 10 }} alt="" /> {e.currency}
              </Box>
            </MenuItem>
          ))}
        </TextField>

        <div className={classes.buttonMarginStyle}>
          {/* {loading ? <LinearProgress /> : null} */}

          <Button
            variant="contained"
            className={classes.buttonStyle}
            color="primary"
            disabled={loading}
            fullWidth
            type="submit">
            {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
            Submit
          </Button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default CurrencyRateCreate;
